import { TGetBusinessOrAccountTransactionsRequestParams } from '../types/TransactionData';

export const getBusinessOrAccountTransactionHistoryParams = (
  options: TGetBusinessOrAccountTransactionsRequestParams
) => {
  const {
    startDate,
    endDate,
    walletIds,
    customerIds,
    transactionTypes,
    bankTransactionTypes,
    sortByField,
    sortByDirection,
    page,
    size
  } = options || {};
  const urlParams = new URLSearchParams();

  if (startDate) {
    urlParams.append('startDate', startDate);
  }

  if (endDate) {
    urlParams.append('endDate', endDate);
  }

  if (walletIds) {
    urlParams.append('walletIds', walletIds.join(','));
  }

  if (customerIds) {
    urlParams.append('customerIds', customerIds.join(','));
  }

  if (transactionTypes) {
    urlParams.append('transactionTypes', transactionTypes.join(','));
  }

  if (bankTransactionTypes) {
    urlParams.append('bankTransactionTypes', bankTransactionTypes.join(','));
  }

  if (sortByField) {
    urlParams.append('sortByField', sortByField);
  }

  if (sortByDirection) {
    urlParams.append('sortByDirection', sortByDirection);
  }

  if (page) {
    urlParams.append('page', page.toString());
  }

  if (size) {
    urlParams.append('size', size.toString());
  }

  return urlParams.toString();
};
